export default "__VITE_ASSET__CgWdSa9n__"